import { DropDownOption } from '../types';

export const convertOptionToAutoComplete = (option?: string | number): DropDownOption => {
    const opFormat = option?.toString() || '';
    return { _id: opFormat, name: opFormat };
};

export function convertOptionsToAutoComplete(options: readonly string[]): DropDownOption[] {
    if (!options || !options?.length) return [];
    return [...new Set(options)].map(convertOptionToAutoComplete);
}
